"use client";

import React, { useState, useEffect } from "react";
import { FaBell } from "react-icons/fa"; 
import { makeRequestAuth } from "../../_config/api"; 

export default function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const res = await makeRequestAuth("post", "/admin/getAdminNotifications");
        if (res?.error === false) {
          setNotifications(res.data || []);
        }
        localStorage.setItem("admin_last_seen_notif", new Date().toISOString());
        await makeRequestAuth("post", "/admin/markAdminNotificationsRead");
      } catch (error) {
        console.error("Failed to fetch notifications");
      } finally {
        setLoading(false);
      }
    };
    fetchNotifications();
  }, []);

  return (
    <div className="p-4 bg-white dark:bg-gray-900 mx-4 rounded-xl shadow-md border border-purple-300 dark:border-gray-700">
      <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-5">
        Recent Notifications
      </h2>

      {loading ? (
        <p className="text-center text-gray-500 mt-10">Loading...</p>
      ) : notifications.length === 0 ? (
        <p className="text-center text-gray-500 mt-10">No notifications found.</p>
      ) : (
        <div className="flex flex-col gap-3">
          {notifications.map((item) => (
            <div
              key={item._id}
              className="bg-gray-100 dark:bg-[#1F2533] p-4 rounded-xl flex items-start gap-3 border border-gray-200 dark:border-white/10 shadow-sm hover:shadow-md hover:-translate-y-[2px] transition-all duration-200"
            >
              {/* Icon */}
              <div className="bg-[#24ADD7] min-w-[42px] h-[42px] rounded-lg flex items-center justify-center shadow">
                <FaBell className="text-white text-lg" />
              </div>

              {/* Text Area */}
              <div className="flex-1">
                <h3 className="text-base font-semibold text-gray-800 dark:text-white leading-tight">
                  {item.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-300 text-xs mt-1 leading-snug">
                  {item.message}
                </p>
                <span className="text-gray-500 dark:text-gray-400 text-[10px] mt-2 block">
                  {new Date(item.createdAt).toLocaleString()}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
